import info from "../../info.jsonc";
const contact_methods: { name: string; link: string; icon?: string }[] = info.contact;
export function Contact() {
  return (
    <div className="max-w-2xl mx-auto py-12 px-4 md:px-6">
      <h1 className="text-3xl md:text-4xl font-bold mb-8">Get in Touch</h1>

      <div className="space-y-8">
        <p className="text-lg text-zinc-300">
          Feel free to reach out if you want to collaborate or just say hi!
        </p>

        <div className="flex flex-col gap-4">
          {contact_methods.map((method, i) => (
            <a
              key={i}
              href={method.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 p-4 bg-zinc-900 border border-zinc-800 rounded-lg hover:border-cyan-500/50 transition-colors"
            >
              <span className={method.icon} />
              <i className="text-cyan-400">{method.name}</i>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
